import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const companyApi = createApi({
  reducerPath: 'companyApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/contractor/companies' }),
  tagTypes: ['Company'],
  endpoints: (builder) => ({
    getCompany: builder.query({
      query: (id) => `/${id}`,
      providesTags: ['Company']
    }),
    getCompanies: builder.query({
      query: (searchParams = '') => searchParams,
      providesTags: ['Company']
    }),
    getCompanySizes: builder.query({
      query: () => 'sizes'
    }),
    createCompany: builder.mutation({
      query: (body) => ({
        method: 'POST',
        body: { company: body }
      }),
      invalidatesTags: ['Company']
    }),
    updateCompany: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${id}`,
        method: 'PATCH',
        body: { company: body }
      }),
      invalidatesTags: ['Company']
    }),
    getCompanySelector: builder.query({
      query: (searchParams = '') => `selector${searchParams}`
    }),
    getCompanySelectorById: builder.query({
      query: (id) => `selector/${id}`
    })
  })
})

const {
  useGetCompanyQuery,
  useUpdateCompanyMutation,
  useGetCompanySizesQuery,
  useGetCompaniesQuery,
  useCreateCompanyMutation,
  useGetCompanySelectorQuery,
  useGetCompanySelectorByIdQuery
} = companyApi

export {
  companyApi,
  useGetCompanyQuery,
  useUpdateCompanyMutation,
  useGetCompanySizesQuery,
  useGetCompaniesQuery,
  useCreateCompanyMutation,
  useGetCompanySelectorQuery,
  useGetCompanySelectorByIdQuery
}